// @flow
/* globals DST_ENVIRONMENT */
import * as r from 'ramda';

// As this variable might not be defined as it is passed in via webpack
// we need to try and access it. If it throws an error on access
// then it hasn't been provided. Which is fine as we don't expect it to
// be during production. Therefore we need to setup the production object
const environment: Object = r.tryCatch(
  () => (DST_ENVIRONMENT),
  r.always({}),
)(null);

export default environment;
